module.exports = __webpack_public_path__ + "static/media/client4.ad344842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/client4.png
// module id = 301
// module chunks = 0